/**
 * A list of explicit default non-color values.
 */
const nonColors = [
  "transparent",
  "currentColor",
  "inherit",
  "revert",
  "initial",
];
export default nonColors;
